import React from "react";
import "./SubjectTabs.css";

const SubjectTabs = ({ subjectTabs, setCurrentSubject, currentSubject }) => {
  return (
    <div className="ncert-subjects-wrapper">
      {subjectTabs?.map((sub) => (
        <div
          key={sub.sub_id}
          className={`ncert-sub ${
            currentSubject === sub.sub_name ? "ncert-sub-active" : ""
          }`}
          onClick={() => setCurrentSubject(sub.sub_name)}
        >
          {" "}
          <img src={sub.sub_icon} alt="icon" />
          {sub.sub_name}
          <div className="ncert-sub-progress">{sub.sub_progress_percent}%</div>
        </div>
      ))}
    </div>
  );
};

export default SubjectTabs;
